var status = false;

var script2 = document.createElement('script');
script2.type = 'text/javascript';
script2.src =
'https://cdnjs.cloudflare.com/ajax/libs/jquery-cookie/1.4.1/jquery.cookie.min.js';


if (typeof Shopify.resizeImage === 'undefined') {
document.write("\u003cscript src=\"\/\/www.theguushop.com\/cdn\/shopifycloud\/shopify\/assets\/themes_support\/api.jquery-5c7ec8e704495947a6ad26f717237512a227840fb65bdc0a32b7de1521602445.js\" type=\"text\/javascript\"\u003e\u003c\/script\u003e");
}

$('head').append(script2);
status = true;
if (jQuery.cookie == undefined) {
!(function(a) {
'function' == typeof define && define.amd
? define(['jquery'], a)
: 'object' == typeof exports
? a(require('jquery'))
: a(jQuery);
})(function(a) {
function b(a) {
return h.raw ? a : encodeURIComponent(a);
}
function c(a) {
return h.raw ? a : decodeURIComponent(a);
}
function d(a) {
return b(h.json ? JSON.stringify(a) : String(a));
}
function e(a) {
0 === a.indexOf('"') &&
(a = a
.slice(1, -1)
.replace(/\\"/g, '"')
.replace(/\\\\/g, '\\'));
try {
return (
(a = decodeURIComponent(a.replace(g, ' '))),
h.json ? JSON.parse(a) : a
);
} catch (b) {}
}
function f(b, c) {
var d = h.raw ? b : e(b);
return a.isFunction(c) ? c(d) : d;
}
var g = /\+/g,
h = (a.cookie = function(e, g, i) {
if (void 0 !== g && !a.isFunction(g)) {
if (
((i = a.extend({}, h.defaults, i)), 'number' == typeof i.expires)
) {
var j = i.expires,
k = (i.expires = new Date());
k.setTime(+k + 864e5 * j);
}
return (document.cookie = [
b(e),
'=',
d(g),
i.expires ? '; expires=' + i.expires.toUTCString() : '',
i.path ? '; path=' + i.path : '',
i.domain ? '; domain=' + i.domain : '',
i.secure ? '; secure' : ''
].join(''));
}
for (
var l = e ? void 0 : {},
m = document.cookie ? document.cookie.split('; ') : [],
n = 0,
o = m.length;
o > n;
n++
) {
var p = m[n].split('='),
q = c(p.shift()),
r = p.join('=');
if (e && e === q) {
l = f(r, g);
break;
}
e || void 0 === (r = f(r)) || (l[q] = r);
}
return l;
});
(h.defaults = {}),
(a.removeCookie = function(b, c) {
return void 0 === a.cookie(b)
? !1
: (a.cookie(b, '', a.extend({}, c, { expires: -1 })), !a.cookie(b));
});
});
}
var lastPart = window.location.href.split('/').pop();
lastPart = lastPart.split('?')[0];
var pathname = window.location.pathname;
var isProducts = pathname.split('/')[1];
var isCollection = pathname.split('/')[1];
var isCollectionWithProduct = pathname.split('/')[3];
var productCount = 0;
$(document).ready(function() {
setTimeout(function() {
if (
isProducts == 'products' ||
isProducts == 'cart' ||
(isCollection == 'collections' &&
isCollectionWithProduct == 'products') ||
isCollection == 'collections'
) {
var pHandle = lastPart;
if (
Shopify.shop == 'buykud588.myshopify.com' &&
isCollection == 'collections'
) {
} else {

jdata = '{"data":{"id":606,"enable_app":1,"store_id":"850","title":"Recently Viewed","number_of_products":"10","truncate_product_title":1,"truncate_product_title_limit":null,"show_hide_price":1,"enable_buy_now_button":1,"buy_now_text":"Buy Now","section_title_font_size":"30","display_productpage":"1","display_cartpage":"0","buynow_btn_bg_color":"#f2cc5c","image_size":"300x300","store_currency":"$"},"currency":"USD"}';
var pHandle = lastPart;
var objectData = jQuery.parseJSON(jdata);
var obj = objectData.data;
var currency = objectData.currency;
var enable_app = obj.enable_app;
var store_id = obj.store_id;
var title = obj.title;
var number_of_products = obj.number_of_products;
var enable_truncate_title = obj.truncate_product_title;
var truncate_product_title_limit = obj.truncate_product_title_limit;
var enable_price = obj.show_hide_price;
var enable_buy_now_button = obj.enable_buy_now_button;
var buy_now_text = obj.buy_now_text.replace(/Diamond/g,"");
var section_title_font_size = obj.section_title_font_size;
var display_homepage = obj.display_homepage;
var display_collectionpage = obj.display_collectionpage;
var display_productpage = obj.display_productpage;
var display_cartpage = obj.display_cartpage;
var image_size = obj.image_size;
var buynow_btn_bg_color = obj.buynow_btn_bg_color;
var currency_symbol = obj.store_currency;
var flag = false;
if (isProducts == 'cart') {
if (display_cartpage == true) var flag = true;
else var flag = false;
} else if (
isProducts == 'products' ||
isCollection == 'collections' ||
(isCollection == 'collections' &&
isCollectionWithProduct == 'products')
) {
if (display_productpage == true) var flag = true;
else var flag = false;
}
if (enable_app == 1) {
$('head').append(
'<style type="text/css">.product-box{min-height:290px;-ms-touch-action: pan-y;touch-action: pan-y;} #tech-dignity-recent-view{margin-top:30px} #tech-dignity-recent-view .title-head h1{text-align:center;} .td-slider-wrapper{ margin: 0 auto; }.td-slider-wrapper ul li{text-align:center;} .td-slider-wrapper ul li .td-item-content{ text-align: center; margin-top: 5px; } .td-price{font-weight: 900} .td-slider-wrapper ul li .td-title a{ color: #000000; font-size: 0.8rem; font-weight: 600; } .td-slider-wrapper ul li .td-buy-now-box{ padding-top: 10px; padding-bottom: 10px; } .td-slider-wrapper ul li .td-buy-now-box .td-buy-now{ padding: 10px 25px;color: #000000; text-decoration: none; }.td-flexslider ul li.product-box .item a img{ width:auto;max-width:100%;margin:0 auto}.td-flexslider .flex-direction-nav a:before{font-size: 34px;color: rgba(195, 195, 195, 0.8) !important;}  </style>'
);
$('head').append(
'<style>.td-buy-now-box a.td-buy-now{background-color:' +
buynow_btn_bg_color +
'}</style>'
);
if (isProducts == 'cart') {
var checkFooter = $('footer').length;
var checkMain = $('main').length;
var checkshopify_footer = $('#shopify-section-footer').length;
if (checkshopify_footer >= 1) {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertBefore(
$('#shopify-section-footer')
);
}
if (checkMain >= 1) {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertAfter(
$('main')
);
} else if (checkFooter >= 1) {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertBefore(
$('footer')
);
} else {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertBefore(
$('footer')
);
}
} else if (isCollection == 'products') {
var checkMain = $('main').length;
var checkshopify_footer = $('#shopify-section-footer').length;
if (checkshopify_footer >= 1) {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertBefore(
$('#shopify-section-footer')
);
}
if (checkMain >= 1) {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertAfter(
$('main')
);
} else {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertBefore(
$('footer')
);
}
} else if (isCollection == 'collections') {
var checkMain = $('main').length;
var checkshopify_footer = $('#shopify-section-footer').length;
if (checkshopify_footer >= 1) {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertBefore(
$('#shopify-section-footer')
);
}
if (checkMain >= 1) {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertAfter(
$('main')
);
} else {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertBefore(
$('footer')
);
}
} else {
$("<div id='tech-dignity-recent-view' class='page-width'></div>").insertBefore(
$('footer')
);
}
$('#tech-dignity-recent-view').append(
'<div class="title-head"></div><section style="padding-left:1px" class="grid__item slider td-slider-wrapper td-recentview-product"><div class="grid grid--uniform grid--view-items"> <ul class="slides recently-slides"></ul></div></section>'
);

if (jQuery.cookie == undefined) {
!(function(a) {
'function' == typeof define && define.amd
? define(['jquery'], a)
: 'object' == typeof exports
? a(require('jquery'))
: a(jQuery);
})(function(a) {
function b(a) {
return h.raw ? a : encodeURIComponent(a);
}
function c(a) {
return h.raw ? a : decodeURIComponent(a);
}
function d(a) {
return b(h.json ? JSON.stringify(a) : String(a));
}
function e(a) {
0 === a.indexOf('"') &&
(a = a
.slice(1, -1)
.replace(/\\"/g, '"')
.replace(/\\\\/g, '\\'));
try {
return (
(a = decodeURIComponent(a.replace(g, ' '))),
h.json ? JSON.parse(a) : a
);
} catch (b) {}
}
function f(b, c) {
var d = h.raw ? b : e(b);
return a.isFunction(c) ? c(d) : d;
}
var g = /\+/g,
h = (a.cookie = function(e, g, i) {
if (void 0 !== g && !a.isFunction(g)) {
if (
((i = a.extend({}, h.defaults, i)),
'number' == typeof i.expires)
) {
var j = i.expires,
k = (i.expires = new Date());
k.setTime(+k + 864e5 * j);
}
return (document.cookie = [
b(e),
'=',
d(g),
i.expires
? '; expires=' + i.expires.toUTCString()
: '',
i.path ? '; path=' + i.path : '',
i.domain ? '; domain=' + i.domain : '',
i.secure ? '; secure' : ''
].join(''));
}
for (
var l = e ? void 0 : {},
m = document.cookie
? document.cookie.split('; ')
: [],
n = 0,
o = m.length;
o > n;
n++
) {
var p = m[n].split('='),
q = c(p.shift()),
r = p.join('=');
if (e && e === q) {
l = f(r, g);
break;
}
e || void 0 === (r = f(r)) || (l[q] = r);
}
return l;
});
(h.defaults = {}),
(a.removeCookie = function(b, c) {
return void 0 === a.cookie(b)
? !1
: (a.cookie(b, '', a.extend({}, c, { expires: -1 })),
!a.cookie(b));
});
});
}
var pHandle;
if (isProducts == 'products') {
pHandle = lastPart;
}
$('.title-head h1').css(
'font-size',
18 + 'px'
);
var pLimit = number_of_products;
var pPointer = 0;
if ($.cookie('tech-dignity-recent-view') == undefined) {
if (pHandle && (isProducts == 'products' || isCollectionWithProduct == 'products')) {
$.cookie('tech-dignity-recent-view', lastPart, {
expires: 365,
path: '/'
});
}
}
var currentProducts = [];
if ($.cookie('tech-dignity-recent-view') != undefined) {
currentProducts = $.cookie('tech-dignity-recent-view').split(
','
);
}
if (currentProducts.length > 0) {
$('#_rvp').show();
}

if(currentProducts.indexOf(pHandle) > -1){
  currentProducts.splice(currentProducts.indexOf(pHandle),1)
}
if (currentProducts.indexOf(pHandle) == -1 ) {
if (currentProducts.length >= pLimit) {
currentProducts.unshift;
}
if(isProducts == 'products' || isCollectionWithProduct == 'products' ){
currentProducts.push(pHandle);
}

}
var newArray = currentProducts.filter(function(v) {
return v !== '';
});
if (newArray.length > 0) {
  if(newArray.length > 10){
                            newArray = newArray.slice(-10);
                        }
jQuery.cookie('tech-dignity-recent-view', newArray.join(','), {
expires: 365,
path: '/'
});
}


window.price1 = "";


$.each(newArray.reverse(), function(i, e) {
if (pPointer >= pLimit || e == '') {
return false;
} else {
pPointer += 1;
Shopify.getProduct(e, function(product) {
var slide_pro_url = '';
if (product.url) {
var parts = product.url.split('/');
slide_pro_url = parts[parts.length - 1];
} else {
slide_pro_url = product.handle;
}
if (
pHandle != slide_pro_url &&
slide_pro_url != undefined
) {
productCount++;
if (productCount == 1) {
$('.title-head').append(
  '<div class="title-head"><h2 class="td-center section-header__title rel_hr" style="font-weight:600;">' +
  title +
  '</h2></div>'
);
}
if (parseInt(enable_truncate_title) == 1) {
var truncated_title = product.title.replace(/Diamond/g,"").substring(
0,
30
) ;
truncated_title = truncated_title;
} else {
var truncated_title = product.title;
}
var productContainer = $('<li />', {
class: 'product-box carousel-cell grid__item medium-up--one-quarter small--one-half'
});
var productBox = $('<div />', { class: 'item' });
var productImg = $('<div />', {
class: 'rv-product-img'
});
var plink = $('<a />', {
alt: product.title,
title: product.title,
href: product.url
});
var plink2 = $('<a />', {
alt: product.title,
title: product.title,
href: product.url,
html: truncated_title
});
var pTitle = $('<label/>', { class: 'td-title subheading grid-view-item__title three-rem-height ' });
var item_content = $('<div/>', {
class: 'td-item-content'
});
var quick_button = $('<button/>', {
class: 'btn btn-default quick-view-addtocart-button',
"data-trackurl":product.url,
"data-productHandle":product.handle,
html: 'Add To Cart'
});
var item_addtocart_box = $('<div/>', {
class: 'td-buy-now-box'
});
var pImage = $('<img />', {
class: 'rv__responsive',
src: resizeImage(product.featured_image, image_size)
});
var pImageWrap = $('<div />', {
class: 'rv__img_wrap'
});
var priceformate = '';
if (currency == 'GBP') {
priceformate = Shopify.formatMoney(
product.price,
''
);
} else if (currency == 'NGN') {
priceformate = Shopify.formatMoney(
product.price,
''
);
} else if (currency == 'PHP') {
priceformate = Shopify.formatMoney(
product.price,
''
);
} else {
if (
currency_symbol !== '' &&
currency_symbol != 'undefined'
) {

priceformate = Shopify.formatMoney(
product.price,
""
);

//                           priceformate = Shopify.formatMoney(
//                             product.price,
//                             currency_symbol + ''
//                           );
} else {
priceformate = Shopify.formatMoney(
product.price,
'$'
);
}
}
//  priceformate = recenCurrency(priceformate);
if (enable_price == 1 && enable_price != '') {
var pPrice = $('<p />', {
class: 'td-price sfs product-price__price product-price__sale',
html: priceformate
});
}
if (enable_buy_now_button == 1 && buy_now_text != '') {
var pAddToCart = $('<a />', {
class: 'td-buy-now',
title: product.title,
href: product.url,
html: buy_now_text
});
}
productImg.append(plink);
pImageWrap.append(pImage);
plink.append(pImageWrap);
pTitle.append(plink2);
productBox.append(productImg);
item_content.append(pTitle);
item_content.append(pPrice);
productBox.append(item_content);
productBox.append(quick_button);
productContainer.append(productBox);
$('.td-slider-wrapper ul.slides').append(
productContainer
);
flexLoad(status);
}
});
}
});
}

}
}
}, 850);
});
function resizeImage(src, size) {
if (size == null) {
return src;
}
if (size == 'master') {
return src.replace(/http(s)?:/, '');
}
var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
if (match != null) {
var prefix = src.split(match[0]);
var suffix = match[0];
return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
} else {
return null;
}
}
function flexLoad(status) {

setTimeout(function() {
$('.recently-slides').flickity({
  // options
  cellAlign: 'left',
  contain: false,
  pageDots:false,
  prevNextButtons:false,
  freeScroll:true

});
}, 800);
}


function recenCurrency(amount){
oldCurrency = "USD";
newCurrency = Currency.cookie.read();
newFormat = Currency.moneyFormats[newCurrency]['money_with_currency_format'];
return  Currency.formatMoney(Currency.convert(parseInt(amount.replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency), newFormat);
}